// src/utils/apiBase.js
// Build a same-origin API base whenever possible. We prefer window.location.origin
// so that Vercel dev (http://localhost:3000) and deployed origins both work
// without hardcoding dev ports. As a fallback (SSR or static render), allow
// VITE_APP_BASE_URL to supply the origin. We normalize to end with "/api".

function normalizeBase(originish) {
  if (!originish) return "";
  const trimmed = String(originish).trim().replace(/\/+$/, "");
  if (!trimmed) return "";
  return trimmed.endsWith("/api") ? trimmed : `${trimmed}/api`;
}

const originBase =
  typeof window !== "undefined" && window.location?.origin
    ? normalizeBase(window.location.origin)
    : "";

const envBase = normalizeBase(import.meta.env?.VITE_APP_BASE_URL || "");

export const API_BASE = originBase || envBase || "/api";

/** Safe join: apiUrl("/items/42") -> "<base>/items/42" */
export function apiUrl(path = "") {
  const p = String(path || "");
  const base = API_BASE.replace(/\/+$/, "");
  const suffix = p.startsWith("/") ? p : `/${p}`;
  return `${base}${suffix}`;
}
